import { render, staticRenderFns } from "./MultipleMatchPure.vue?vue&type=template&id=99ec7e64&scoped=true&"
import script from "./MultipleMatchPure.vue?vue&type=script&lang=js&"
export * from "./MultipleMatchPure.vue?vue&type=script&lang=js&"
import style0 from "./MultipleMatchPure.vue?vue&type=style&index=0&id=99ec7e64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ec7e64",
  null
  
)

export default component.exports